import { useEffect } from "react";
import { App } from "@capacitor/app";
import {
  flushPatrolScanOutbox,
  PATROL_OUTBOX_FLUSH_INTERVAL_MS,
} from "@/features/patrol/offline/patrolScanOutbox";
import {
  flushShiftActionOutbox,
  hydrateShiftOutboxIntoQueryClient,
} from "@/features/shifts/offline/shiftActionOutbox";
import { useAuthContext } from "@/lib/authContext";

/**
 * Hydrates queued shift state, then flushes shift actions (clock-in/out) before patrol scans.
 */
export function OfflineOutboxSync() {
  const { isAuthenticated, isInitialized } = useAuthContext();

  useEffect(() => {
    if (!isInitialized || !isAuthenticated) return;
    void hydrateShiftOutboxIntoQueryClient();
  }, [isInitialized, isAuthenticated]);

  useEffect(() => {
    const tick = async () => {
      await hydrateShiftOutboxIntoQueryClient();
      await flushShiftActionOutbox();
      await flushPatrolScanOutbox();
    };

    void tick();
    const intervalId = setInterval(() => void tick(), PATROL_OUTBOX_FLUSH_INTERVAL_MS);
    let resumeHandle: { remove: () => void } | undefined;
    void App.addListener("resume", () => {
      void tick();
    })
      .then((h) => {
        resumeHandle = h;
      })
      .catch(() => {
        /* Web / test environments may not support App listeners */
      });
    return () => {
      clearInterval(intervalId);
      resumeHandle?.remove();
    };
  }, []);

  return null;
}
